import React from 'react';
import PropTypes from 'prop-types';

import ServiceNotices from '../ServiceNotices';
import BoxWithAlert from './BoxWithAlert';

const Results = ({ formattedData }) => {
  if (!formattedData) {
    return null;
  }

  const { outstanding, completed } = formattedData;
  // If there isn't an alert text, then, there are no outstanding campaigns
  const hasOutstandingCampaigns = !outstanding.alert;
  // handle outstanding campaigns
  const outstandingContent = outstanding.alert ? (
    <BoxWithAlert
      title={outstanding.title}
      amountIdentifier={outstanding.amountIdentifier}
      text={outstanding.alert}
      subtitle={outstanding?.subtitle}
      showOpeningParagraph={hasOutstandingCampaigns}
    />
  ) : (
    <ServiceNotices hasBorder data={outstanding} />
  );

  return (
    <>
      {outstandingContent}
      <ServiceNotices data={completed} />
    </>
  );
};

Results.propTypes = {
  formattedData: PropTypes.shape({
    outstanding: PropTypes.shape({
      alert: PropTypes.string,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      amountIdentifier: PropTypes.string,
      status: PropTypes.string,
    }),
    completed: PropTypes.shape({
      alert: PropTypes.string,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      amountIdentifier: PropTypes.string,
      status: PropTypes.string,
    }),
  }).isRequired,
};

export default Results;
